import { Provider } from "react-redux";

function ReduxStoreProvider({ store, children }) {
  return <Provider store={store}>{children}</Provider>;
}

export default ReduxStoreProvider;
